module.exports = __webpack_public_path__ + "img/donora-hero.0e45d4d8.jpg";